module.exports = __webpack_public_path__ + "media/images/top/icon/gray/ico_arrow-05047e4160f136d374053666ceecfb61.svg";